import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        jobSearchFeature: {
          module: () => import('./job-search.module').then((m) => m.JobSearchModule),
        },
      }
    }),
  ]
})
export class JobSearchFeatureModule {
}
